import {FC} from 'react'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {checkIsActive, KTSVG, WithChildren} from '../../../../helpers'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  msIcon?: string
  hasBullet?: boolean
  badgeCount?: number
}

const SidebarMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  msIcon,
  hasBullet = false,
  badgeCount,
}) => {
  const {pathname, search} = useLocation()
  const [pathOnly, queryPart = ''] = (to || '').split('?')
  const linkTab = new URLSearchParams(queryPart).get('tab')
  const currentTab = new URLSearchParams(search).get('tab')

  let isActive = checkIsActive(pathname, pathOnly)
  // Config tabs share the same path — require matching ?tab=
  // Default tab on the page is "cities" when query is absent
  const effectiveTab = currentTab || 'cities'
  if (isActive && linkTab) {
    isActive = effectiveTab === linkTab
  } else if (isActive && pathOnly === '/apps/tours/configurations' && !linkTab) {
    isActive = !currentTab
  }

  return (
    <div>
      <Link
        to={to}
        className={[
          'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-all duration-150 mb-0.5',
          isActive
            ? 'font-bold bg-white/60'
            : 'font-medium hover:bg-slate-200/50',
        ].join(' ')}
        style={{
          color: isActive ? '#1d4ed8' : '#64748b',
          textDecoration: 'none',
          borderRight: isActive ? '4px solid #1d4ed8' : '4px solid transparent',
        }}
      >
        {msIcon && (
          <span
            className='material-symbols-outlined flex-shrink-0'
            style={{
              fontSize: '20px',
              fontVariationSettings: isActive
                ? "'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24"
                : "'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24",
            }}
          >
            {msIcon}
          </span>
        )}
        {!msIcon && icon && (
          <span className='flex-shrink-0'>
            <KTSVG path={icon} className='svg-icon-2' />
          </span>
        )}
        {!msIcon && !icon && hasBullet && (
          <span className='flex-shrink-0 w-1.5 h-1.5 rounded-full bg-current opacity-40 ml-1' />
        )}

        <span className='flex items-center flex-1 min-w-0 gap-2'>
          <span className='truncate'>{title}</span>
          {badgeCount != null && badgeCount > 0 && (
            <span
              className='flex-shrink-0 min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-bold flex items-center justify-center text-white'
              style={{backgroundColor: '#ba1a1a'}}
            >
              {badgeCount > 99 ? '99+' : badgeCount}
            </span>
          )}
        </span>
      </Link>
      {children}
    </div>
  )
}

export {SidebarMenuItem}
